import { YOO_FINDS_H5_CDN_URL } from "@/common/domains";

const ROOT = `${YOO_FINDS_H5_CDN_URL}/h5/activity/2026/spring`;

export const SPRING_YOOFINDS_LOGO = `${ROOT}/yoofinds-spring-logo-v2.png`;
export const SPRING_BANNER_RIGHT = `${ROOT}/banner-right.svg`;
export const SPRING_BANNER_LEFT = `${ROOT}/banner-left.svg`;
